var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.445,
    height: 26.435,
    viewBox: "0 0 25.445 26.435",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8f003c;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "location_city_FILL0_wght400_GRAD0_opsz48",
    className: "cls-1",
    d: "M8.12,31.035A2.112,2.112,0,0,1,6,28.914V13.435a2.112,2.112,0,0,1,2.12-2.12h6.609V8.947a2.576,2.576,0,0,1,.035-.424,1.622,1.622,0,0,1,.124-.406,2.32,2.32,0,0,1,.212-.371,2.371,2.371,0,0,1,.265-.318L17.98,4.883a1.115,1.115,0,0,1,1.484,0L22.08,7.427a1.771,1.771,0,0,1,.477.689,2.261,2.261,0,0,1,.159.83v8.234h6.609a2.112,2.112,0,0,1,2.12,2.12v9.613a2.112,2.112,0,0,1-2.12,2.12Zm0-2.12h3.746V25.168H8.12Zm0-5.867h3.746V19.3H8.12Zm0-5.867h3.746V13.435H8.12Zm8.729,11.733H20.6V25.168H16.849Zm0-5.867H20.6V19.3H16.849Zm0-5.867H20.6V13.435H16.849Zm0-5.867H20.6V7.569H16.849Zm8.729,17.6h3.746V25.168H25.579Zm0-5.867h3.746V19.3H25.579Z",
    transform: "translate(-6 -4.6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/city.63c59c7349ea2d3c9e0a7a5e7e16c556.svg";
export { ForwardRef as ReactComponent };